import React, { createContext, useContext, useState, useEffect } from 'react';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile
} from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { auth, db } from '../config/firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

// Firebase config for secondary app (to create users without logging out admin)
const firebaseConfig = {
  apiKey: "AIzaSyA2G6RtXg6IbLaE1QwDdcc06_xGM3WLYOQ",
  authDomain: "amcicrayazilimi.firebaseapp.com",
  projectId: "amcicrayazilimi",
  storageBucket: "amcicrayazilimi.firebasestorage.app",
  messagingSenderId: "723775855966",
  appId: "1:723775855966:web:84e5e3c1e3f67f6a0b8e35"
};

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Yeni kullanıcı oluşturma (admin oturumunu kapatmadan)
  async function signup(email, password, fullName, role = 'STAFF') {
    // Secondary app instance oluştur
    const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
    const secondaryAuth = getAuth(secondaryApp);
    
    try {
      // Yeni kullanıcıyı secondary auth ile oluştur
      const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
      const user = userCredential.user;
      
      // Display name güncelle
      await updateProfile(user, { displayName: fullName });
      
      // Firestore'a kullanıcı bilgilerini kaydet
      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        email: email,
        fullName: fullName,
        role: role,
        createdAt: new Date().toISOString()
      });
      
      // Secondary auth'dan çıkış yap (admin oturumu korunur)
      await signOut(secondaryAuth);
      
      return userCredential;
    } finally {
      // Secondary app'i temizle
      try {
        await secondaryApp.delete();
      } catch (e) {
        console.log('Secondary app cleanup');
      }
    }
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      
      if (user) {
        // Get user data from Firestore
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserData(userDoc.data());
        } else {
          // Create user document if doesn't exist
          const newUserData = {
            uid: user.uid,
            email: user.email,
            fullName: user.displayName || user.email.split('@')[0],
            role: 'ADMIN',
            createdAt: new Date().toISOString()
          };
          await setDoc(doc(db, 'users', user.uid), newUserData);
          setUserData(newUserData);
        }
      } else {
        setUserData(null);
      }
      
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userData,
    signup,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
